import { render, staticRenderFns } from "./PublicProcessPage.vue?vue&type=template&id=2394df8c&scoped=true&"
import script from "./PublicProcessPage.vue?vue&type=script&lang=js&"
export * from "./PublicProcessPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2394df8c",
  null
  
)

export default component.exports